module.exports = __webpack_public_path__ + "img/TechCavalryArm1_ua.92f49506.webp";